import React from 'react';
import {Navigate, useLocation} from "react-router-dom";
import {useAppSelector} from "../store";
import {isAuthenticatedSelector} from "../store/slice/auth";

interface AuthProps {
    redirectPath?: string
    allowAuthenticated?: boolean
    allowUnauthenticated?: boolean
    children?: any
}

const Auth = (
    {
        redirectPath = "/login",
        allowAuthenticated = false,
        allowUnauthenticated = false,
        children
    }: AuthProps
) => {

    const isAuthenticated = useAppSelector(isAuthenticatedSelector);

    const shouldRedirect = (allowAuthenticated && !isAuthenticated) || (allowUnauthenticated && isAuthenticated);

    const location = useLocation();

    if (shouldRedirect) {
        return (
            <Navigate to={redirectPath} state={{ from: location }} replace />
        )
    }

    return children

}


export default Auth;
